import script from "./TreatmentsTrials.vue?vue&type=script&setup=true&lang=js"
export * from "./TreatmentsTrials.vue?vue&type=script&setup=true&lang=js"

import "./TreatmentsTrials.vue?vue&type=style&index=0&id=403d59c6&lang=scss&scoped=true"
import "./TreatmentsTrials.vue?vue&type=style&index=1&id=403d59c6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403d59c6"]])

export default __exports__